import { memo } from 'react';
import Logo from 'assets/img/L_GrCloutier_SansDescr_RGB_Renv_v1.svg';
import LogoMobile from 'assets/img/L_GrCloutier_ICONE_RGB_Renv_v1.svg';
import { Menu } from 'lucide-react';
import { Button } from 'components/ui/button';
import { RouterLink } from 'components/navigation';
import SettingsMenu from './SettingsMenu';
import FavoriteList from './FavoriteList';
import { useSearch } from 'hooks/useSearch';
import SearchBarHeader from './SearchBarHeader/SearchBarHeader';

type HeaderProps = {
  toggleMobileMenu: () => void;
};

function Header({ toggleMobileMenu }: HeaderProps) {
  const {
    draftQuery,
    setDraftQuery,
    commitQuery,
    suggestions,
    isSuggestionsLoading,
    favoriteDocuments,
    isFavoriteDocumentsLoading,
  } = useSearch({ navigateOnCommit: true, fetchMainResults: false });

  return (
    <div className="w-full bg-primary">
      <header className="mx-auto flex h-full w-full border-spacing-x-10 items-center justify-between gap-4 border-b-2 border-secondaryYellow py-4">
        <div className="hidden w-full items-center justify-between gap-20 px-2 lg:flex">
          <div className="flex shrink-0 items-center gap-2">
            <Button
              variant="ghost"
              className="hover:bg-secondaryYellow xl:hidden [&_svg]:size-6!"
              size="icon-lg"
              onClick={toggleMobileMenu}
            >
              <Menu color="white" className="h-32 w-32" />
            </Button>
            <RouterLink to="/" className="shrink">
              <div className="flex shrink-0 items-center gap-3 text-white">
                <img src={Logo} alt="Logo" className="hidden h-16 w-auto xl:block" />
                <img src={LogoMobile} alt="Logo Mobile" className="h-16 w-auto xl:hidden" />
                <div className="h-8 border border-white xl:hidden"></div>
                <span className="ml-2 pt-2 font-merriweather text-xl font-bold whitespace-nowrap">Boîte à Outils</span>
              </div>
            </RouterLink>
          </div>
          <SearchBarHeader
            minSearchLength={3}
            draftQuery={draftQuery}
            onDraftChange={setDraftQuery}
            onCommit={commitQuery}
            suggestions={suggestions}
            isSuggestionsLoading={isSuggestionsLoading}
          />
          <SettingsMenu
            documents={favoriteDocuments}
            isLoading={isFavoriteDocumentsLoading}
            toggleMobileMenu={toggleMobileMenu}
          />
        </div>

        <div className="flex w-full flex-col gap-4 px-4 lg:hidden">
          <div className="flex w-full items-center justify-between">
            <div className="flex items-center gap-2">
              <Button
                variant="ghost"
                className="hover:bg-secondaryYellow [&_svg]:size-6!"
                size="icon-lg"
                onClick={toggleMobileMenu}
              >
                <Menu color="white" className="h-32 w-32" />
              </Button>
              <RouterLink to="/">
                <div className="flex shrink-0 items-center gap-3 text-white">
                  <img src={LogoMobile} alt="Logo Mobile" className="h-16 w-auto" />
                  <div className="h-8 border border-white"></div>
                  <span className="ml-2 font-merriweather text-xl font-bold whitespace-nowrap">Boîte à Outils</span>
                </div>
              </RouterLink>
            </div>

            <div className="flex items-center gap-4">
              <div className="hidden">
                <FavoriteList documents={favoriteDocuments} isLoading={isFavoriteDocumentsLoading} />
              </div>
              <SettingsMenu
                documents={favoriteDocuments}
                isLoading={isFavoriteDocumentsLoading}
                toggleMobileMenu={toggleMobileMenu}
              />
            </div>
          </div>
          <SearchBarHeader
            minSearchLength={3}
            draftQuery={draftQuery}
            onDraftChange={setDraftQuery}
            onCommit={commitQuery}
            suggestions={suggestions}
            isSuggestionsLoading={isSuggestionsLoading}
          />
        </div>
      </header>
    </div>
  );
}

export default memo(Header);
